module.exports = __webpack_public_path__ + "static/AppleBooks-fda0d2a660985a3c6c5b286ef27040ba.png";